<div
  class="modal fade"
  bsModal
  #staticModal="bs-modal"
  [config]="{ backdrop: 'static' }"
  tabindex="-1"
  role="dialog"
  aria-labelledby="mySmallModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-md">
    <form
      (submit)="confirmUpdate($event)"
      #completedForm="ngForm"
      ngNativeValidate
    >
      <div class="modal-content panel-default">
        <div class="modal-header panel-heading">
          <h4 class="modal-title pull-left">Update Complaint</h4>
          <button
            type="button"
            class="close pull-right"
            aria-label="Close"
            (click)="close()"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label for="">Status</label>
            <app-complaint-status-select
              [model]="complaintStatus"
              [required]="true"
            ></app-complaint-status-select>
            <small>What status to you wish to assign to this complaint?</small>
          </div>

          <div class="form-group">
            <label for="note">Note</label>
            <textarea
              name="note"
              class="form-control"
              rows="7"
              [required]="true"
            ></textarea>
            <small>Any note to accompany this status change?</small>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default" (click)="close()">
            Cancel
          </button>
          <button type="submit" class="btn btn-success" [disabled]="disabled">
            Save
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
